import { useQuery } from '@tanstack/react-query';
import { organizationService } from '@services/organization';
import { useAppSelector } from '@redux/hooks';

/**
 * Fetches whether invoicing is paused for the CURRENT organization, fresh from the
 * server. Used by the invoicing page so a paused org sees the wait message even when
 * the persisted Redux org state is stale (it only refreshes on login / org switch).
 */
export const useMyInvoicingPaused = () => {
  const { organizationId } = useAppSelector((state) => state.organization);

  return useQuery({
    queryKey: ['organizations', 'myInvoicingPaused', organizationId],
    queryFn: () => organizationService.getMyInvoicingPaused(),
    enabled: !!organizationId,
  });
};

export default useMyInvoicingPaused;
